module.exports = __webpack_public_path__ + "img/neotag-logo.02757ba9.png";